import { ExecArgBase, dataToExecData } from '../ExecArgBase.js';
/**
 * @category Contract Exec Arguments
 */
export default class ExecArgNeptuneDeposit extends ExecArgBase {
    static fromJSON(params) {
        return new ExecArgNeptuneDeposit(params);
    }
    toData() {
        return {};
    }
    toExecData() {
        return dataToExecData('lend', this.toData());
    }
}
